import React, { useState } from "react";
import { MailCheck, Send } from "lucide-react";
import { API_BASE_URL } from "../api";
import { Button, Field, SectionHeader, SurfaceCard, TextareaField } from "../components/designSystem";

function AdminSendNewsletter() {
  const [subject, setSubject] = useState("");
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const sendNewsletter = async (event) => {
    event.preventDefault();
    setSuccess("");
    setError("");

    if (!subject || !content) {
      setError("Subject and content required.");
      return;
    }

    setLoading(true);
    const token = localStorage.getItem("token");

    try {
      const res = await fetch(`${API_BASE_URL}/api/newsletter/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ subject, content })
      });
      const data = await res.json();
      if (res.ok && data.success) {
        setSuccess(data.message);
        setSubject("");
        setContent("");
      } else {
        setError(data.error || "Failed to send newsletter.");
      }
    } catch {
      setError("Network error.");
    }

    setLoading(false);
  };

  return (
    <div className="mx-auto max-w-4xl space-y-6">
      <SurfaceCard className="overflow-hidden bg-[radial-gradient(circle_at_top_left,_rgba(14,165,233,0.16),_transparent_22%),linear-gradient(135deg,_#ffffff,_#f8fafc)] dark:bg-[radial-gradient(circle_at_top_left,_rgba(14,165,233,0.12),_transparent_22%),linear-gradient(135deg,_#111827,_#0f172a)]">
        <SectionHeader eyebrow="Newsletter" title="Send a newsletter to all subscribers" description="Compose the message and deliver it through the backend newsletter admin flow." />
      </SurfaceCard>

      {error ? <SurfaceCard><p className="text-sm font-medium text-rose-600 dark:text-rose-300" role="alert">{error}</p></SurfaceCard> : null}
      {success ? <SurfaceCard><p className="text-sm font-medium text-emerald-600 dark:text-emerald-300" role="status">{success}</p></SurfaceCard> : null}

      <div className="grid gap-6 xl:grid-cols-[1fr_0.9fr]">
        <SurfaceCard>
          <SectionHeader eyebrow="Compose" title="Draft the newsletter" description="Use a clear subject and concise message body so subscribers can scan the update quickly." />
          <form className="mt-6 space-y-5" onSubmit={sendNewsletter}>
            <Field label="Subject" type="text" placeholder="Subject" value={subject} onChange={e => setSubject(e.target.value)} required />
            <TextareaField label="Newsletter Content" rows={10} placeholder="Write the newsletter content." value={content} onChange={e => setContent(e.target.value)} required />
            <Button type="submit" variant="brand" className="w-full" disabled={loading}>
              <Send className="h-4 w-4" />
              {loading ? "Sending..." : "Send Newsletter"}
            </Button>
          </form>
        </SurfaceCard>

        <SurfaceCard>
          <SectionHeader eyebrow="Delivery" title="Admin sending note" description="This admin page sends one message to all newsletter subscribers returned by the backend." />
          <div className="mt-6 flex items-start gap-3 rounded-3xl border border-slate-200 bg-slate-50 p-4 dark:border-gray-700 dark:bg-gray-900">
            <MailCheck className="mt-1 h-5 w-5 text-sky-600 dark:text-sky-300" />
            <p className="text-sm leading-7 text-slate-600 dark:text-slate-300">This tool is better suited to clear product, support, or release communication than long-form marketing campaigns.</p>
          </div>
        </SurfaceCard>
      </div>
    </div>
  );
}

export default AdminSendNewsletter;
